import { createReducer } from '@reduxjs/toolkit'
import { IStateBreakdowns } from './TReducer'
import { Actions_Breakdowns } from './Actions'

const initialState: IStateBreakdowns = {
  isLoading: false,
  data: [],
  responseInfo: null,
}

const ReducerBreakdowns = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_Breakdowns.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_Breakdowns.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_Breakdowns.store.saveBreakdowns, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_Breakdowns.store.clearBreakdowns, () => {
      return initialState
    })
    .addCase(Actions_Breakdowns.store.editBreakdown, (state, action) => {
      if (!state.data) {
        return {
          ...state,
        }
      }

      const payload = action.payload
      const updatedBreakdowns = state.data?.map((breakdown) => {
        if (breakdown.id !== payload.data?.id) {
          return breakdown
        }
        return {
          ...breakdown,
          ...payload.data,
        }
      })
      return {
        ...state,
        data: updatedBreakdowns,
      }
    })
})

export default ReducerBreakdowns
